import { useContext } from 'react';

import { PermissionsContext } from './PermissionsProvider';
import { Page } from '@/constants';

import { canAccess, domainsForPage, isAvailabilityOnly } from './capabilities';

type UsePermissions = {
  canAccess: (page: Page) => boolean;
  vendorIdsFor: (page: Page) => Set<string>;
  isAvailabilityOnly: boolean;
  loading: boolean;
};

export const usePermissions = (): UsePermissions => {
  const ctx = useContext(PermissionsContext);
  if (!ctx) {
    throw new Error('usePermissions must be used within a PermissionsProvider');
  }
  const { domains, vendorIdsByDomain, loading } = ctx;

  return {
    loading,
    canAccess: (page) => canAccess(page, domains),
    isAvailabilityOnly: isAvailabilityOnly(domains),
    vendorIdsFor: (page) =>
      new Set(domainsForPage(page).flatMap((domain) => [...(vendorIdsByDomain.get(domain) ?? [])])),
  };
};
